import { json } from 'd3';
import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['pagination', 'entries'];
  pagination_rendered = []

  connect() {
    $('#pagination').hide()
    $('#spinner').hide()
  }

  scroll(){
    let next_page = this.paginationTarget.querySelector("a[rel='next']")
    if(next_page == null) { return }

    let url = next_page.href
    var body = document.body

    if(window.pageYOffset >= body.scrollHeight - window.innerHeight){
      this.loadMore(url)
    }
  }

  loadMore() {
    let next_page = this.paginationTarget.querySelector("a[rel='next']");
    if(next_page == null) return;
    let url = next_page.href;
    $(this.spinnerTarget).show();
    Rails.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      success: (response) => {
        this.entriesTarget.insertAdjacentHTML('beforeend', response.entries);
        this.paginationTarget.innerHTML = response.pagination;
        $(this.spinnerTarget).hide();
      }
    });
  }

}